import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [pendingApproval, setPendingApproval] = useState(false);
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPendingApproval(false);
    setLoading(true);
    try {
      const res = await login({ email, password });
      loginUser(res.data.token, res.data.user, res.data.refreshToken);
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      if (data?.pendingApproval) {
        setPendingApproval(true);
      } else {
        setError(data?.error || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen auth-gradient-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full glass-card rounded-2xl shadow-xl border border-white/60 p-8">
        <div className="text-center mb-8">
          <img
            src="/chart-auditer-ai-logo.svg"
            alt="Chart Auditer AI logo"
            className="h-20 w-auto max-w-full mx-auto mb-3 object-contain"
          />
          <h1 className="text-3xl font-bold text-gray-800">
            <span className="text-teal-600">Chart</span>Audit AI
          </h1>
          <p className="text-gray-500 mt-2">Sign in to your account</p>
        </div>

        {pendingApproval && (
          <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-lg mb-4">
            <p className="font-semibold">Account Pending Approval</p>
            <p className="text-sm mt-1">Your account is still being reviewed by an administrator. You'll be able to log in once approved.</p>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">{error}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-white/80" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-white/80" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white font-semibold py-2.5 rounded-xl shadow-md hover:shadow-lg disabled:opacity-50">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-gray-500 text-sm mt-6">
          Don't have an account? <Link to="/register" className="text-teal-600 hover:text-teal-700 font-medium hover:underline">Register</Link>
        </p>
      </div>
    </div>
  );
}
